import { z } from "zod";
export const GoalBasedFinancialPlanDateIdSchema = z
    .string()
    .startsWith("GBFP_PD_")
    .regex(/^GBFP_PD_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("GoalBasedFinancialPlanDateId");
export const GoalBasedFinancialPlanIdSchema = z
    .string()
    .startsWith("GBFP_") // GBFP => Goal Based Financial Plan
    .regex(/^GBFP_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("GoalBasedFinancialPlanId");
export const GoalBasedFinancialPlanAccountIdSchema = z
    .string()
    .startsWith("GBFP_A_")
    .regex(/^GBFP_A_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("GoalBasedFinancialPlanAccountId");
export const GoalBasedFinancialPlanExpenseIdSchema = z
    .string()
    .startsWith("GBFP_E_")
    .regex(/^GBFP_E_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("GoalBasedFinancialPlanExpenseId");
export const GoalBasedFinancialPlanGoalIdSchema = z
    .string()
    .startsWith("GBFP_G_")
    .regex(/^GBFP_G_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("GoalBasedFinancialPlanGoalId");
export const GoalBasedFinancialPlanIncomeIdSchema = z
    .string()
    .startsWith("GBFP_I_")
    .regex(/^GBFP_I_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("GoalBasedFinancialPlanIncomeId");
export const GoalBasedFinancialPlanInsuranceIdSchema = z
    .string()
    .startsWith("PID_") // PID => Plan Insurance Id
    .regex(/^PID_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("PlanInsuranceId");
export const GoalBasedFinancialPlanSavingsIdSchema = z
    .string()
    .startsWith("GBFP_S_")
    .regex(/^GBFP_S_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("GoalBasedFinancialPlanSavingsId");
//# sourceMappingURL=ids.js.map